module.exports = __webpack_public_path__ + "static/media/truck.06b02d04.svg";